<template>
	<div class="pagination">
		<div
			v-for="(num, index) in numPages"
			:key="num"
			class="circle"
			:class="{ selected: index == currPage, active: index <= currPage }"
			@click="showElement(index)"
		></div>
		<div class="page-num">{{ currPage }}/{{ numPages }}</div>
		<div class="buttons-wrapper">
			<ja-arrow-button
				name="prev-page"
				:disabled="currPage == 1"
				direction="left"
				@click.native="goPrev"
			></ja-arrow-button>
			<ja-arrow-button
				name="next-page"
				:disabled="currPage == numPages"
				direction="right"
				@click.native="goNext"
			></ja-arrow-button>
		</div>
	</div>
</template>
<script>
import ArrowButton from './ArrowButton';
export default {
	components: {
		jaArrowButton: ArrowButton
	},
	props: {
		numPages: {
			type: Number,
			default: 1
		},
		currPage: {
			type: Number,
			default: 1
		}
	},
	methods: {
		goPrev() {
			if (this.currPage > 1) {
				this.$emit('goPrevPage');
			}
		},
		goNext() {
			if (this.currPage < this.numPages) {
				this.$emit('goNextPage');
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.pagination {
	display: flex;
	align-items: center;
	.page-num {
		flex-grow: 1;
		color: #687682;
		font-family: 'RobotoMedium';
		font-size: 12px;
		letter-spacing: 1px;
		line-height: 16px;

		@media (min-width: $breakpoint-mid) {
			font-size: 14px;
			line-height: 18px;
			letter-spacing: 1.17px;
		}
	}

	button {
		&:first-child {
			margin-right: 16px;
		}
	}
}
</style>
